module.exports = __webpack_public_path__ + "img/fk.8527a00f.svg";